<template>
  <div>
    <div class="box_mode content_wrapper">
      <br>
      <br>
      <br>
      <br>
      <div class="home_area">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="section_title animated a_fu">
                <div class="h1">Materias</div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class=" mt-4">
            <div class="mapa d-flex">
              <div class="sector" v-bind:class="{'active':(ubmaps[0] =='Familia')}" v-on:click="UbiCompt('Familia')">
                <span class="name">Familia</span>
                <span class="icon icon-familia"></span>
              </div>
              <div class="sector" v-bind:class="{'active':(ubmaps[0] =='Civil')}" v-on:click="UbiCompt('Civil')">
                <span class="name">Civil</span>
                <span class="icon icon-civil"></span>
              </div>
              <div class="sector" v-bind:class="{'active':(ubmaps[0] =='Laboral')}" v-on:click="UbiCompt('Laboral')">
                <span class="name">Laboral</span>
                <span class="icon icon-laboral"></span>
              </div>
              <div class="sector" v-bind:class="{'active':(ubmaps[0] =='Cobranza')}" v-on:click="UbiCompt('Cobranza')">
                <span class="name">Cobranza</span>
                <span class="icon icon-cobranza"></span>
              </div>
              <div class="sector" v-bind:class="{'active':(ubmaps[0] =='Garantia')}" v-on:click="UbiCompt('Garantia')">
                <span class="name">Garantía</span>
                <span class="icon icon-penal"></span>
              </div>
              <div class="sector" v-bind:class="{'active':(ubmaps[0] =='Top')}" v-on:click="UbiCompt('Top')">
                <span class="name">Oral en lo Penal</span>
                <span class="icon icon-penal"></span>
              </div>
            </div>
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  <div class="brand_area sp100 animated a_fu" id="territorio-result">
    <CorteApeTerr
      :tabs="tabs"
      :cgraf="cgraf"
      :secc="secc"
      :cort="'0'"
      :comp="ubmaps[0]"
      :texto="texto"
      :cifras="cifras"
      :titulo="comtit"
      :subtitulo="'Seleccione el ítem para revisar las cifras de la Materia ' + ubmaps[0]"
      :key="keyCorteTerr"
    >
    </CorteApeTerr>
    <br>
    <br>
  </div>
  <input v-model="ubicacionmaps" style="display: none">
</div>
</template>
<script>
import countTo from 'vue-count-to';
import CorteApeTerr from '@/components/CorteApeTerr.vue';
import {
  mapState,
  mapActions,
} from 'vuex';
export default {
  methods: {
    ...mapActions([
      'actubicacionMaps',
      'actcifras',
      'acttexto',
      'actmodulos',
      'actanioi',
    ]),
    UbiCompt: function(a) {
      if (typeof a === 'object') {
        this.ubmaps = a;
      } else {
        this.ubmaps = [];
        this.partes = a.split('-');
        this.ubmaps = this.partes;
      }

      if (this.ubmaps[0] == 'Garantia') {
        this.comtit = 'Garantía';
      } else if (this.ubmaps[0] == 'Top') {
        this.comtit = 'Oral en lo Penal';
      } else {
        this.comtit = this.ubmaps[0];
      }
      this.keyCorteTerr += 1;
      this.cgraf = [];
      this.axios.get(this.ipapi + 'modulos/0/' + this.ubmaps[0] + '/0')
          .then((response) => {
            this.m = [];
            this.m.push(JSON.parse(response.data[0].GRAFICOS));
            this.tabs = this.m[0].TEXTO;
            this.secc = this.m[0].SECCION;
            for (const i in this.secc) {
              this.axios.get(this.ipapi + 'textos/competencia/' + this.secc[i] + '/' + this.ubmaps[0])
                  .then((response) => {
                    this.cgraf.push(response.data);
                  })
                  .catch(function(error) {
                    console.log(error);
                  });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      this.axios.get(this.ipapi + 'cifras_clave/competencia/' + this.ubmaps[0] + '/' + (this.anioI === '' ? (new Date().getFullYear()) - 2 : this.anioI))
          .then((response) => {
            this.actcifras(response.data);
          })
          .catch(function(error) {
            console.log(error);
          });
      this.axios.get(this.ipapi + 'textos/competencia/' + this.ubmaps[0] + '/0')
          .then((response) => {
            this.acttexto(response.data);
          })
          .catch(function(error) {
            console.log(error);
          });
    },
  },
  components: {countTo, CorteApeTerr},
  mounted() {
    this.$watch(
    	() => {
    	},
        (newVal, oldVal) => {
        },
    );
    console.log('Component mounted. test');
    this.ubmaps = [];
    this.ubmaps = this.$route.params.ubicacion.split('-');
    this.UbiCompt(this.ubmaps);
  },
  watch: {
    'deep': true,
  	'ubicacionmaps': function(newVal, oldVal) {
      this.UbiCompt(newVal);
    },
  },
  data() {
    return {
      tabs: [],
      cgraf: [],
      secc: [],
      ubmaps: [],
      comtit: '',
      keyCorteTerr: 0,
    };
  },
  computed: {
    ...mapState([
      'ubicacionmaps',
      'cifras',
      'texto',
      'modulos',
      'ipapi',
      'anioI',
    ]),
  },
};
</script>
